import { useEffect, useRef } from "react";

const getWsUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  const base = envUrl ? envUrl.replace(/\/$/, "") : window.location.origin;
  return base.replace(/^http/, "ws") + "/api/ws";
};

export function useScadaWS(onMessage) {
  const wsRef = useRef(null);
  const cbRef = useRef(onMessage);
  useEffect(() => { cbRef.current = onMessage; }, [onMessage]);

  useEffect(() => {
    let stop = false;
    let retry = 0;
    const connect = () => {
      if (stop) return;
      const wsUrl = getWsUrl();
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;
      ws.onmessage = (e) => {
        try { cbRef.current && cbRef.current(JSON.parse(e.data)); } catch {}
      };
      ws.onclose = () => {
        if (stop) return;
        retry = Math.min(retry + 1, 6);
        setTimeout(connect, 500 * 2 ** retry);
      };
      ws.onerror = () => { try { ws.close(); } catch {} };
      ws.onopen = () => { retry = 0; };
    };
    connect();
    return () => { stop = true; try { wsRef.current?.close(); } catch {} };
  }, []);
}
